import { IframeV4EventsHandlers } from "./../../../iframeV4/services/iframeV4-eventHandler.service";
import { Modal, ModalService } from "@core-services/modal.service";
import {
	AfterViewInit,
	ChangeDetectorRef,
	Component,
	DestroyRef,
	ElementRef,
	HostBinding,
	inject,
	Inject,
	Injector,
	NgZone,
	OnDestroy,
	OnInit,
	ViewChild,
	DOCUMENT
} from "@angular/core";

import { BehaviorSubject, combineLatest, interval, Observable } from "rxjs";

import { Angulartics2GoogleAnalytics, Angulartics2GoogleTagManager } from "angulartics2";

import { ErrorClass, Language, LegalRightsRevokedError, OfflineError, User, UserVerificationState } from "@models";

import { ActivationEnd, NavigationEnd, NavigationStart, Router } from "@angular/router";
import { config } from "@config";
import { FiatWalletService } from "@main-services/wallet/fiat_wallet.service";
import { TradableWalletListService } from "@main-services/wallet/tradable_wallet_list.service";
import "cookie-banner"; // Check https://stenciljs.com/docs/angular/ to see the integration
import { CookieBannerService, CookieBannerState } from "@main-services/cookie-banner.service";
import { PriceAlertService } from "@main-services/price-alert.service";
import {
	catchError,
	distinct,
	filter,
	map,
	skipWhile,
	startWith,
	switchMap,
	take,
	takeWhile,
	throttle
} from "rxjs/operators";
import { MembersDataService } from "@core-services/members-data.service";
import { InitService } from "@core-services/init.service";
import { ServiceNames } from "@models/service_enums";
import { Script } from "@models/script";
import { ScriptManagerService } from "@core-services/script-manager.service";
import { AuthService } from "bp-authorization-lib";
import {
	ADVANCED_TRADING_TOOLTIP_CLICKED,
	NAVBAR_SCROLL_TOP_DISTANCE,
	VERIFICATION_MODAL_ROUTE
} from "@helpers/constants";
import { BrazeService } from "@core-services/braze.service";
import { SendTransaction } from "@models/transaction";
import { LaunchDarklyService, LD_FLAG } from "@core-services/launch-darkly/launch-darkly.service";
import { AccountService } from "@modules/account/services/account.service";
import { WINDOW } from "@main-services/window.service";
import { LoadingService } from "@main-services/loading.service";
import { SegmentService } from "@main-services/segment.service";
import { UserService } from "@main-services/user.service";
import { SavingsService } from "@main-services/savings.service";
import { FiatService } from "@main-services/currency";
import { LegalAcceptanceComponent } from "@modules//main/components/legal-acceptance-modal/legal-acceptance.component";
import { ApicallOption, ApicallService } from "@core-services/apicall.service";
import { ApiErrorBusService } from "@core-services/api-error-bus.service";
import { TranslationService } from "@core-services/translation.service";
import { CustomModal } from "@modules/core/components/base-modals";
import { TradeTypeDecisionModalComponent } from "@modules/trade/modals/trade-type-decision-modal/trade-type-decision-modal.component";
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";
import { Feature } from "@models/feature-list";
import { BestFacade } from "@modules/new_account/features/my-best/domain/+state/best.facade";
import { BestModel } from "@modules/new_account/features/my-best/domain/entities/best.model";
import { UniversalModalService } from "@modules/+new/shared/universal-modal/universal-modal.service";
import { FiatDepositEntryService } from "@modules/+new/payments/features/fiat-deposit/infrastructure/fiat-deposit-entry.service";
import { SendEntryPointService } from "@modules/+new/payments/features/send/domain/send-entry-point.service";
import { Aml5ModalComponent } from "@modules/main/components/aml5-modal/aml5-modal.component";
import { DarkModeService } from "@core-services/dark-mode.service";
import { NewProfileFacade } from "@modules/main/components/profile/new-profile/state/new-profile.facade";
import { VerificationModalFacade } from "@modules/verification/modal/state/verification-modal.facade";
import { CashplusUpdateService } from "@modules/cashplus/+state/cashplus-update.service";
import { UserMembershipData, UserMembershipService } from "@main-services/user-membership.service";
import { CashPlusFacade } from "@modules/cashplus/+state/cashplus.facade";
import { KycService } from "@modules/kyc/services/kyc.service";
import { TaxesFacade } from "@modules/taxes/domain/+state/taxes.facade";
import { CountriesService } from "@core-services/countries.service";
import { OrdersCountFacade } from "@modules/limit-orders/services/orders-count.facade";
import { AdvancedTradingFacade } from "@modules/advanced-trading/advanced-trading.facade";
import { AssetWalletFetchService } from "@core-services/asset-wallet.service";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { AdvTradingTrackingService } from "@modules/advanced-trading/services/adv-trading-tracking.service";
import { TermsAndConditionsService } from "@modules/shared/terms-and-conditions/services/terms-and-conditions.service";
import { AntiPhishingBlockType } from "@modules/shared/modals/anti-phishing-code-modal/interfaces";
import { AntiPhishingCodeService } from "@modules/shared/modals/anti-phishing-code-modal/services/anti-phishing-code.service";
import { AntiPhishingCodeModalService } from "@modules/shared/modals/anti-phishing-code-modal/services/anti-phishing-code-modal.service";
import { ModalCloseReason } from "@modules/+new/shared/universal-modal/entities/modal-close-reason.enum";
import { AutoStakingTrackingFacade } from "@modules/staking/domain/+state/auto-staking-tracking.facade";
import { AgreementBundle } from "@modules/shared/terms-and-conditions/entities/terms-and-conditions.model";
import { WEB3_MERGE_PHASE, Web3Facade } from "@modules/web3/+state/web3.facade";
import { PortfolioFacade } from "@modules/portfolio/domain/portfolio.facade";
import { FEAT_GATES, StatsigClientService } from "@core-services/statsig/statsig.service";
import { RudderstackService } from "@main-services/rudderstack.service";
import { Helper } from "@helpers/functions";

@UntilDestroy()
@Component({
	selector: "bitpanda",
	templateUrl: "./app.component.html",
	styleUrls: ["./app.component.scss", "./bp-navbar.scss"],
	providers: [BestFacade, AdvTradingTrackingService, AdvancedTradingFacade],
	standalone: false
})
export class AppComponent implements OnInit, OnDestroy, AfterViewInit {
	@ViewChild("cookieComponent", { static: false })
	public cookieBannerComponent: ElementRef;
	public featureList: typeof Feature = Feature;
	public isOverlayOpen: boolean = false;

	private oldIEisIgnored: boolean = false;
	private offline: boolean = false;
	private lastScrollDownState: boolean = false;
	private mainToggled: boolean = false;
	private toggledProfile: boolean = false;
	private pendingWalletTransactions: number = 0;
	private oldOffset: number = NAVBAR_SCROLL_TOP_DISTANCE;
	private initiated: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
	public isNotificationActive$: Observable<boolean> = this.launchDarklyService.isActive$(LD_FLAG.NOTIFICATIONS);
	private aml5ModalReference: Modal = null;
	private images: HTMLImageElement[] = [];
	private readonly preloadedImages: string[] = ["/assets/images/404-panda.png"];
	private isScrollingDown: boolean = false;
	private isModalOpen = false;
	private showFusionTooltip = true;

	// Hotjar
	private readonly hotjarScriptName: string = "hotjarScript";
	// Hotjar poll
	private readonly hotjarPollScriptName: string = "hotjarPollScript";
	private readonly hotjarPollName: string = "coinpoll_"; // + language added afterwards (eg: coinpoll_EN);
	private readonly hotjarPollMinLevel: number = 1; // Only users with VIP Level >= 1 can see the poll
	private insertedHotjarPoll: boolean = false;
	private insertedHotjar: boolean = false;

	public isDarkSurfaceAppContainer: boolean = false;

	private readonly dependentServices: string[] = [
		ServiceNames.INIT_ASSETS_SERVICE,
		ServiceNames.CRYPTO_WALLET,
		ServiceNames.FIAT_WALLET,
		ServiceNames.CONTACT,
		ServiceNames.PRICE_ALERT,
		ServiceNames.FIAT,
		ServiceNames.PROFILE,
		ServiceNames.SAVINGS,
		ServiceNames.USER,
		ServiceNames.STATSIG
	];

	public profile$ = this.profileFacade.getProfile$();
	public userMembership$: Observable<UserMembershipData> = this.userMembershipService.getMembership$();
	public verificationState$: Observable<VerificationStatusModel> = this.userService.verificationState$.pipe(
		map((state) => {
			const isVerificationPending = state === UserVerificationState.PENDING_APPROVAL;
			const isNotYetVerified = User.isNotYetVerified(state) && !this.userService.hasIgnoredVerify;
			const isDocumented = state === UserVerificationState.DOCUMENTED;
			const isOnfidoEligible = isVerificationPending || isDocumented;
			const showVerifyButton = isNotYetVerified && !isVerificationPending;

			return { isVerificationPending, isNotYetVerified, isDocumented, isOnfidoEligible, showVerifyButton };
		})
	);

	public showFusionTopEntryPoint$: Observable<boolean> = this.statsigClientService.isFeatureActive(
		FEAT_GATES.FUSION_EXPERIENCE_ENABLED
	);

	public showGlobalBanner$: Observable<boolean> = this.statsigClientService.isFeatureActive(
		FEAT_GATES.UK_FINPROM_GLOBAL_WARNING
	);

	public showAdvancedTradingBanner$: Observable<boolean> = this.launchDarklyService.isActive$(
		LD_FLAG.ADVANCED_TRADING
	);

	public supportUrl = "";
	public baseUrl = config.baseUrl;

	private readonly advTradingFacade = inject(AdvancedTradingFacade);
	private readonly web3Facade = inject(Web3Facade);
	public phase$ = this.web3Facade.getMergePhase();
	public web3MergePhase = WEB3_MERGE_PHASE;
	bareApp$: Observable<boolean>;
	private v4ThemeListenerAttached = false;
	private iframeResizeObserver: ResizeObserver = null;
	private readonly v4AppBaseUrl = config.V4AppBaseUrl;

	public constructor(
		private readonly accountService: AccountService,
		private readonly apicallService: ApicallService,
		private readonly tradableWalletListService: TradableWalletListService,
		private readonly fiatWalletService: FiatWalletService,
		private readonly fiatService: FiatService,
		private readonly modalService: ModalService,
		private readonly priceAlertService: PriceAlertService,
		private verificationModalFacade: VerificationModalFacade,
		private readonly profileFacade: NewProfileFacade,
		private readonly savingsService: SavingsService,
		private readonly bestFacade: BestFacade,
		private readonly translationService: TranslationService,
		private readonly router: Router,
		private readonly userService: UserService,
		private readonly angulartics2GoogleTagManager: Angulartics2GoogleTagManager, // This starts routetracking just by importing it
		private readonly angulartics2GoogleAnalytics: Angulartics2GoogleAnalytics, // This starts routetracking just by importing it
		@Inject(DOCUMENT) private readonly document: Document,
		@Inject(WINDOW) private readonly window,
		private readonly loadingService: LoadingService,
		private readonly cookieBannerService: CookieBannerService,
		private readonly elRef: ElementRef,
		private readonly injector: Injector,
		private readonly ngZone: NgZone,
		private readonly cdr: ChangeDetectorRef,
		private readonly errorBusService: ApiErrorBusService,
		private readonly membersDataService: MembersDataService,
		private readonly scriptManagerService: ScriptManagerService,
		private readonly authService: AuthService,
		private readonly initService: InitService,
		private readonly segmentService: SegmentService,
		private readonly rudderstackService: RudderstackService,
		private readonly brazeService: BrazeService,
		private readonly launchDarklyService: LaunchDarklyService,
		private readonly universalModalService: UniversalModalService,
		private readonly fiatDepositEntryService: FiatDepositEntryService,
		private readonly sendEntryPoint: SendEntryPointService,
		private readonly darkModeService: DarkModeService,
		private readonly cashPlusUpdateService: CashplusUpdateService,
		private readonly cashPlusFacade: CashPlusFacade,
		private readonly userMembershipService: UserMembershipService,
		private readonly kycService: KycService,
		private readonly taxesFacade: TaxesFacade,
		private readonly countriesService: CountriesService,
		private readonly ordersCountFacade: OrdersCountFacade,
		private readonly assetWalletFetchService: AssetWalletFetchService,
		private readonly destroyRef: DestroyRef,
		private readonly termsAndConditionsService: TermsAndConditionsService,
		private readonly apcModalService: AntiPhishingCodeModalService,
		private readonly apcService: AntiPhishingCodeService,
		private readonly autoStakingTrackingFacade: AutoStakingTrackingFacade,
		private readonly portfolioFacade: PortfolioFacade,
		private readonly statsigClientService: StatsigClientService,
		private IframeV4EventsHandlers: IframeV4EventsHandlers
	) {
		angulartics2GoogleAnalytics.startTracking();
		angulartics2GoogleTagManager.startTracking();

		this.loadLanguages();
		this.loadingService.request();

		// ======== IFRAME RELATED ========

		this.bareApp$ = this.router.events.pipe(
			filter((e): e is NavigationEnd => e instanceof NavigationEnd),
			take(1),
			startWith(null),
			map(() => {
				let s = this.router.routerState.snapshot.root;
				while (s.firstChild) {
					s = s.firstChild;
				}
				const bareApp = s.data?.["bareApp"] === true;
				const fullSizeModal = s.data?.["fullSizeModal"] === true;

				document.body.classList.toggle("fullsize-modal", fullSizeModal);
				document.body.classList.toggle("bare-app", bareApp);

				if (bareApp) {
					this.listenToV4ThemeChanges();
					this.IframeV4EventsHandlers.postMessage({ type: "V3_READY" }, this.v4AppBaseUrl);
					if (window.self !== window.top) {
						document.documentElement.style.overflow = "hidden";
					}
					this.iframeResizeObserver = new ResizeObserver(() => {
						this.IframeV4EventsHandlers.postMessage({
							type: "IFRAME_HEIGHT",
							height: document.body.scrollHeight
						});
					});
					this.iframeResizeObserver.observe(document.body);
				} else {
					darkModeService.setColorTheme();
				}
				return bareApp;
			})
		);

		CustomModal.injector = injector;

		this.router.events.subscribe((event) => {
			if (event instanceof ActivationEnd) {
				// TODO: re-add when we find a way for aux routes to not override it
				// this.isDarkSurfaceAppContainer = !!event.snapshot.data["darkSurface"];
			}

			if (event instanceof NavigationEnd) {
				this.loadingService.release();
			} else if (event instanceof NavigationStart) {
				const segments = event.url.split("/");
				if (segments.length > 0 && !this.accountService.ticker) {
					let page = segments[1];
					if (page.includes("#")) {
						// Remove anchors
						page = page.split("#")[0];
					}
					if (page.includes("?")) {
						// Remove parameters
						page = page.split("?")[0];
					}
					this.accountService.setTitle((page || "home") + "_title");
				}
			}
		});

		const listener = this.modalService.modalSubject;
		listener.subscribe(() => (this.mainToggled = false));

		console.info("starting app");
		this.initService.init("APP");

		combineLatest([this.tradableWalletListService.getList(), this.fiatWalletService.getList()]).subscribe(() => {
			if (this.fiatWalletService.list.length === 0 || this.tradableWalletListService.list.length === 0) {
				return;
			}
			this.pendingWalletTransactions = this.tradableWalletListService.list
				.map((w) => (w ? w.getPendingTransactionCount() : 0))
				.concat(this.fiatWalletService.list.map((w) => (w ? w.getPendingTransactionCount() : 0)))
				.reduce((prev: number, currentValue: number) => prev + currentValue);
		});

		this.initService.getWhitelistRouteObservable().subscribe((isWhitelisted: boolean) => {
			this.initiated.next(isWhitelisted);
		});

		if (this.getUser().isLoggedIn) {
			this.init();
			this.initLaunchDarkly();
			this.integrateHotjarPoll();
			this.bestFacade.initAutoUpdates();
			this.checkForNewTerms();
			this.updateStatsigConfig();
		} else {
			this.userService
				.userLoggedIn()
				.pipe(
					skipWhile((loggedIn) => !loggedIn),
					take(1)
				)
				.subscribe(() => {
					this.init();
					this.initLaunchDarkly();
					this.integrateHotjarPoll();
					this.bestFacade.initAutoUpdates();
					this.checkForNewTerms();
					this.updateStatsigConfig();
				});
		}

		this.translationService.languageUpdate$().subscribe((lang: string) => {
			this.authService.setLanguage(lang);
			this.document.documentElement.lang = this.getLanguageIsoCode(lang);
			this.supportUrl = `${config.helpcenterUrl}hc/${lang === "deu" ? "de" : "en"}`;
		});

		this.errorBusService.aml5ErrorReceived
			.pipe(
				untilDestroyed(this),
				throttle(() => interval(200))
			)
			.subscribe(() => {
				this.initiated.next(true);
				this.loadingService.release();
				if (!this.aml5ModalReference || (!!this.aml5ModalReference && !this.aml5ModalReference.isShowing)) {
					this.aml5ModalReference = this.modalService.create(Aml5ModalComponent).present();
				}
			});

		// If we get an error for AA missing, we just reload the home and get the pre-status again for UK
		this.errorBusService.aaErrorReceived
			.pipe(
				untilDestroyed(this),
				throttle(() => interval(200))
			)
			.subscribe(() => {
				window.location.replace("/home");
			});

		this.universalModalService.isOpen$.subscribe((isOpen) => (this.isModalOpen = isOpen));

		// Better handle this FF in a component level to avoid unnecessary calls when user is not in history page
		this.taxesFacade.isTaxesActive$.pipe(untilDestroyed(this)).subscribe((isActive) => {
			if (isActive) {
				this.taxesFacade.fetchUserTaxStatus();
			}
		});
	}

	@HostBinding("class.modal-open") get modalOpen(): boolean {
		return this.isModalOpen;
	}

	// ========= IFRAME RELATED =========
	private listenToV4ThemeChanges(): void {
		if (this.v4ThemeListenerAttached) {
			return;
		}
		this.v4ThemeListenerAttached = true;

		window.addEventListener("message", this.onV4Message);
	}

	private onV4Message = (event: MessageEvent): void => {
		if (!event.data?.type) {
			return;
		}

		if (event.data.type === "BP_THEME_SYNC") {
			this.darkModeService.toggleDarkMode(event.data?.theme || "dark");
		}
	};

	public getUser(): User {
		return this.userService.user;
	}

	public isOffline(): boolean {
		return this.offline;
	}

	public isHidden(): boolean {
		return this.isScrollingDown && !this.mainToggled;
	}

	public send(): void {
		this.sendEntryPoint.openCryptoSendModal({ transaction: new SendTransaction() });
	}

	public tradeInit(): void {
		this.tradingInteractionTracking("Trading Button Clicked");
		this.modalService.create(TradeTypeDecisionModalComponent, {}, { showCloseButton: false }).present();
	}

	public isInitiated(): Observable<boolean> {
		return this.initiated.asObservable();
	}

	public hasAuthFailure(): boolean {
		return this.authService.hasAuthFailure();
	}

	public isProfiletoggled(): boolean {
		return this.toggledProfile;
	}

	public toggleProfile($event: Event = null): void {
		if ($event) {
			$event.stopPropagation();
		}
		this.toggledProfile = !this.toggledProfile;
	}

	public untoggleProfile(): void {
		this.toggledProfile = false;
	}

	public isMainToggled(): boolean {
		return this.mainToggled;
	}

	public toggleMain(isPortfolioClicked: boolean): void {
		this.mainToggled = !this.mainToggled;

		if (isPortfolioClicked) {
			this.navigateToPortfolioOverview();
		}
	}

	public navigateToPortfolioOverview(): void {
		// Reset portfolio overview
		this.portfolioFacade.changeRefreshPortfolioStatus(true);
	}

	public onWindowScroll: () => void = () => {
		const offset = this.document.documentElement.scrollTop;
		const old = this.oldOffset;

		if (Math.abs(old - offset) > 50 || offset > NAVBAR_SCROLL_TOP_DISTANCE) {
			this.isScrollingDown = old <= offset;
			this.oldOffset = Math.max(NAVBAR_SCROLL_TOP_DISTANCE, offset);
			if (this.lastScrollDownState !== this.isScrollingDown) {
				this.lastScrollDownState = this.isScrollingDown;
				this.ngZone.run(() => {
					this.untoggleProfile();
				});
			}
		}

		if (offset <= NAVBAR_SCROLL_TOP_DISTANCE) {
			this.ngZone.run(() => {
				this.cdr.markForCheck();
			});
		}
	};

	public verify(): void {
		this.router.navigate(VERIFICATION_MODAL_ROUTE, {
			skipLocationChange: true
		});
	}

	public isLogin(): boolean {
		return this.router.url.indexOf("login") > -1;
	}

	public logout(): void {
		this.segmentService.reset();
		this.rudderstackService.reset();
		this.router.navigate(["/user/logout"]);
	}

	public ngOnDestroy(): void {
		window.removeEventListener("scroll", this.onWindowScroll);
		window.removeEventListener("message", this.onV4Message);
		this.iframeResizeObserver?.disconnect();
	}

	public ngOnInit(): void {
		this.ngZone.runOutsideAngular(() => {
			window.addEventListener("scroll", this.onWindowScroll, true);
		});
		this.preload(this.preloadedImages);

		// initiate cashplus update service
		this.cashPlusUpdateService.initCashplusPortfolioUpdates();

		// initiate cashplus fetch combined state
		this.cashPlusFacade.fetchCombinedCashPlusState();

		// Get all countries
		this.countriesService.fetchCountries();

		// Get Total Account for Limit Orders
		this.ordersCountFacade.fetchOrdersCount();

		//detect back button and if modal is open, close it, including the overlay
		this.router.events
			.pipe(
				takeUntilDestroyed(this.destroyRef),
				filter((event): event is NavigationStart => event instanceof NavigationStart),
				switchMap((event) => {
					if (event.navigationTrigger === "popstate") {
						this.isModalOpen = false;
					}
					return this.apcService.getAntiPhishingBlockType$.pipe(take(1));
				})
			)
			.subscribe((apcBlockType) => {
				this.setupAPCBlockUX(apcBlockType);
			});
	}

	private setupAPCBlockUX(apcBlockType: AntiPhishingBlockType): void {
		if (apcBlockType === AntiPhishingBlockType.FULL || apcBlockType === AntiPhishingBlockType.HALF) {
			this.apcModalService.openAntiPhishingForceModal(apcBlockType);
		} else {
			this.kycService.checkKycModal();
		}
	}

	public ngAfterViewInit(): void {
		document.addEventListener(
			"focus",
			(event: FocusEvent & { path: HTMLElement[] }) => {
				if (this.toggledProfile) {
					if (!event.path) {
						return;
					}
					if (!event.path.some((el) => el.className && el.className.includes("bp-navbar-account-overlay"))) {
						this.toggledProfile = false;
					}
				}
			},
			true
		);
	}

	public dismissFusionTooltip(): void {
		Helper.setCookie(ADVANCED_TRADING_TOOLTIP_CLICKED, "true");
		this.showFusionTooltip = false;
	}

	public setStakingOverviewFlow(): void {
		this.autoStakingTrackingFacade.updateFlowStarted("profile");
	}

	public isOldIE(): boolean {
		const ua = window.navigator.userAgent;
		let version = -1;

		const msie = ua.indexOf("MSIE ");
		if (msie >= 0) {
			// IE 10 or older => return version number
			version = parseInt(ua.substring(msie + 5, ua.indexOf(".", msie)), 10);
		}

		const trident = ua.indexOf("Trident/");
		if (trident >= 0) {
			// IE 11 => return version number
			const rv = ua.indexOf("rv:");
			version = parseInt(ua.substring(rv + 3, ua.indexOf(".", rv)), 10);
		}

		const edge = ua.indexOf("Edge/");
		if (edge >= 0) {
			// Edge (IE 12+) => return version number
			version = parseInt(ua.substring(edge + 5, ua.indexOf(".", edge)), 10);
		}

		return (version !== -1 ? version < 12 : false) && !this.oldIEisIgnored;
	}

	public ignoreOldIE(): void {
		this.oldIEisIgnored = true;
	}

	public onCookieVisibilityChange($event): void {
		// Load binded banner element
		if (!this.cookieBannerService.cookieBannerComponent) {
			this.cookieBannerService.cookieBannerComponent = this.cookieBannerComponent;
			this.cookieBannerService.componentLoaded();
		}
		this.cookieBannerService.setVisibility($event.detail);
	}

	public onUserAcceptedCookies(_): void {
		if (!this.cookieBannerService.cookieBannerComponent) {
			return;
		}

		this.cookieBannerService.userAcceptedTerms();
	}

	public getLanguage(): string {
		return TranslationService.getLanguageIsoCode().toUpperCase();
	}

	public setLanguage(lang: string): void {
		this.translationService.setLanguage(lang);
	}

	public getLanguageIsoCode(lang: string): string {
		return TranslationService.getLanguageIsoCode(lang);
	}

	public getLanguages(): string[] {
		return TranslationService.LANGUAGES;
	}

	public isOnfidoEligible(): boolean {
		return this.userService.isUnverified || this.getUser().isDocumented();
	}

	private init(): void {
		// Waiting for all dependent services to load their data
		// Then we are showing the nav bar for navigation
		this.initService
			.getInitiatedServicesAsObservable()
			.pipe(
				takeWhile(
					(initiated: string[]) =>
						!this.dependentServices.every((service: string) => initiated.includes(service))
				)
			)
			.subscribe({
				complete: () => {
					this.initiated.next(true);
					if (config.debug) {
						console.log("%cAPP_INIT_DONE", "color:springgreen; font-weight:bold");
					}

					// Handle global api errors, like revoked t&c
					this.errorBusService.errorReceived.pipe(untilDestroyed(this)).subscribe((err) => {
						if (err instanceof LegalRightsRevokedError) {
							if (!this.modalService.stack.some((i) => i.instance instanceof LegalAcceptanceComponent)) {
								// If the legal policy modal is already created, then do nothing
								this.modalService.popAll(); // Close all existing popup
								this.universalModalService.close(ModalCloseReason.close);
								combineLatest({
									members: this.apicallService.get("members"),
									isDynamicTermsActive:
										this.termsAndConditionsService.isDynamictermAndConditionActive$
								}).subscribe(({ isDynamicTermsActive }) => {
									if (isDynamicTermsActive) {
										this.modalService.showModal(LegalAcceptanceComponent, { error: err });
									}
								});
							}
						}
					});
					this.brazeService.init();
				}
			});
		this.fiatWalletService.updateWalletsDefaultFiat();
		this.membersDataService.initMembersData();
		this.priceAlertService.initAlerts();
		this.savingsService.initSavings();
		this.fiatService.initFiat();
		this.profileFacade.fetchProfile();
		this.assetWalletFetchService.initAssetWallets();

		this.showFusionTooltip = Helper.getCookie(ADVANCED_TRADING_TOOLTIP_CLICKED) !== "true";
	}

	private loadLanguages(): void {
		this.translationService.loadCookieLanguage();
		this.apicallService
			.get("languages", new ApicallOption(Language))
			.pipe(
				catchError((error, caught) => {
					if (error instanceof ErrorClass) {
						if (error instanceof OfflineError) {
							this.offline = true;
						}
					} else {
						console.error(error);
					}
					return caught;
				})
			)
			.subscribe((languages) => {
				this.translationService.initLanguages(languages);
			});
	}

	private initLaunchDarkly(): void {
		// LaunchDarkly service must be initialized inside profile$ subscription because we need all data before to call the launchDarkly method
		this.profile$
			.pipe(
				skipWhile((profile) => !profile),
				take(1)
			)
			.subscribe((profile) => {
				this.segmentService.identify({
					// @ts-ignore
					id: profile?.profile_id
				});
				this.rudderstackService.identify(profile?.profile_id, {
					signup_source: "angular webapp",
					language_preference: this.getLanguage(),
					time: new Date().toISOString()
				});
			});
		this.fiatDepositEntryService.initNewDepositFlowStatus();
	}

	private updateStatsigConfig(): void {
		this.profile$
			.pipe(
				skipWhile((profile) => !profile),
				take(1)
			)
			.subscribe((profile) => {
				this.statsigClientService.updateUser(profile.profile_id, profile.email, profile.iso);
			});
	}

	private preload(list: string[]): void {
		list.forEach((href) => {
			const image = new Image();
			image.src = href;
			this.images.push(image);
		});
	}

	// Hotjar Poll code:

	private integrateHotjarPoll(): void {
		// Wait for the user to accept/change Performance cookies preferences
		this.cookieBannerService
			.getStateObs()
			.pipe(
				map((state: CookieBannerState) => state.getPerformance()),
				filter((perf: boolean) => perf),
				distinct(),
				untilDestroyed(this)
			)
			.subscribe(() => {
				this.tryPollAdding();
				this.tryAddHotjar();
			});
	}
	private tryAddHotjar(): void {
		if (!this.insertedHotjar) {
			const { hotjarSiteId } = config.scriptsConfig;
			if (hotjarSiteId && !this.scriptManagerService.hasScript(this.hotjarScriptName)) {
				const jsCode: string = `			
	(function(h,o,t,j,a,r){
        h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};
        h._hjSettings={hjid:${hotjarSiteId},hjsv:6};
        a=o.getElementsByTagName('head')[0];
        r=o.createElement('script');r.async=1;
        r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;
        a.appendChild(r);
    })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');
	`;
				const script: Script = this.scriptManagerService.createScript(
					this.hotjarScriptName,
					jsCode,
					"tag",
					"body"
				);
				this.scriptManagerService.loadScript(script);
				this.insertedHotjar = true;
			}
		}
	}

	private tryPollAdding(): void {
		// Get BEST VIP data
		this.bestFacade.fetchBest();
		this.bestFacade
			.getBestState$()
			.pipe(
				filter((state: BestModel) => !!state),
				take(1)
			)
			.subscribe((bestData: BestModel) => {
				// Check if Performance cookies accepted + Poll not inserted already + Best VIP level > 1.
				if (
					!this.insertedHotjarPoll &&
					bestData.current_vip_levels_threshold?.level >= this.hotjarPollMinLevel
				) {
					if (!this.scriptManagerService.hasScript(this.hotjarPollScriptName)) {
						const coinPollName: string = this.hotjarPollName + this.getLanguage();
						const jsCode: string =
							`
						let attempts = 0;
						const hotjarInterval = setInterval(() => {
							attempts++;
							if (typeof hj !== "undefined" && !!hj) {
								hj('trigger','` +
							coinPollName +
							`');
								clearInterval(hotjarInterval);
							}
							if (attempts >=5)
								clearInterval(hotjarInterval);
						}, 300);`; // Because Hotjar (main library 'hj', not the poll) is injected async by Google Tag Manager, it usually takes half second to be injected and loaded. So try few times to access it and add the poll.
						const script: Script = this.scriptManagerService.createScript(
							this.hotjarPollScriptName,
							jsCode,
							"tag",
							"body"
						);
						this.scriptManagerService.loadScript(script);
						this.insertedHotjarPoll = true;
					}
				}
			});
	}

	public deposit(): void {
		this.tradingInteractionTracking("Deposit Button Clicked");
		this.fiatDepositEntryService.openDeposit();
	}

	public tradingInteractionTracking(trackingName: string): void {
		this.segmentService.track({
			name: trackingName,
			properties: {
				category: "Trading interaction",
				screen_it_happened_on: "home_screen"
			}
		});
		this.rudderstackService.track({
			name: trackingName,
			properties: {
				category: "Trading interaction",
				screen_it_happened_on: "home_screen"
			}
		});
	}

	public onOverlayOpen(): void {
		this.isOverlayOpen = !this.isOverlayOpen;
	}

	public openFusionModal(): void {
		if (this.showFusionTooltip) {
			this.dismissFusionTooltip();
		}
		this.advTradingFacade.navigateToAdvancedTrading("account");
	}

	private checkForNewTerms(): void {
		this.termsAndConditionsService.checkTCaccepted((bundles: AgreementBundle[]) => {
			this.modalService.popAll();
			this.modalService.showModal(LegalAcceptanceComponent, { bundles });
		});
	}
}

export interface VerificationStatusModel {
	isVerificationPending: boolean;
	isNotYetVerified: boolean;
	isDocumented: boolean;
	isOnfidoEligible: boolean;
	showVerifyButton: boolean;
}
